import { SVG, SVGProps } from './svg'

export function IconDrawingSettingPreserveDrawingsActive(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path d="M7.5 8c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1H8.5v15h10.69c-.08.32-.14.66-.17 1H8a.5.5 0 0 1-.5-.5V8Zm17 11.02c-.34.03-.68.09-1 .17V18a.5.5 0 0 1 1 0v1.02ZM18.5 8c0 .28.22.5.5.5h3.8l-8.3 8.3V13a.5.5 0 0 0-1 0v5c0 .28.22.5.5.5h5a.5.5 0 0 0 0-1h-3.8l8.3-8.3V13a.5.5 0 0 0 1 0V8a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5Z" />
      <circle className="fill-green-400" cx="25" cy="25" r="5" />
      <path
        className="fill-white"
        d="M27.8 22.6a.5.5 0 0 1 .1.7l-3.13 4a.5.5 0 0 1-.76.04l-1.87-2a.5.5 0 0 1 .72-.68l1.48 1.57 2.77-3.54a.5.5 0 0 1 .7-.08Z"
      />
    </SVG>
  )
}
